import { render, staticRenderFns } from "./BoxingLogisticsInfoDialog.vue?vue&type=template&id=6b18f959&"
import script from "./BoxingLogisticsInfoDialog.vue?vue&type=script&lang=js&"
export * from "./BoxingLogisticsInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./BoxingLogisticsInfoDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports